<template>
    <div class="login">        
          <h1 id="logo">
            <img src="@/assets/img/layout/admin_logo_b.png" alt="Admin Logo">
          </h1>
          <div class="form">
              <input type="text" class="login_form" id="id" v-model="loginInfo.mngr_mbr_id" placeholder="아이디" />
              <input 
                type="password" 
                class="login_form" 
                v-model="loginInfo.mngr_mbr_pw"
                        placeholder="비밀번호"
                        @keyup.enter="fn_login"
              />
          </div>
          <button class="login_btn" @click="fn_login">로그인</button>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "AdminLogin",
  data: function () {
    return {
      loginInfo : {
        mngr_mbr_id: "",
        mngr_mbr_pw: ""
      }
    };
  },
  methods: {
    fn_login: function () {

          if(this.loginInfo.mngr_mbr_id == ""){
            alert("아이디를 입력하세요");
            return;
          }

          if(this.loginInfo.mngr_mbr_pw == ""){
            alert("패스워드를 입력하세요");
            return;
          }

          axios.post("/api/admin/login", 
                this.loginInfo
          ).then((res) => {
              console.log("@@@@ res : %o",res);
              if(res.data.result == "0"){
                this.$router.push({ name: 'AdminMain'});
              }else{
                if(res.data.result == "1"){
                  alert("아이디와 패스워드가 틀렸습니다.");
                }else{
                  alert("계정이 잠겼습니다. 관리자에게 문의하세요");
                }
              }
          })
          .catch((err) => console.log(err));
    }
  }
}
</script>